var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertDue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#183059"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.33334C11.9342 9.33334 8.5 12.7675 8.5 16.8333C8.5 20.8992 11.9342 24.3333 16 24.3333C20.0658 24.3333 23.5 20.8992 23.5 16.8333C23.5 12.7675 20.0658 9.33334 16 9.33334ZM16 22.6667C12.8383 22.6667 10.1667 19.995 10.1667 16.8333C10.1667 13.6717 12.8383 11 16 11C19.1617 11 21.8333 13.6717 21.8333 16.8333C21.8333 19.995 19.1617 22.6667 16 22.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8332 16V12.6667H15.1665V17.6667H20.1665V16H16.8332ZM20.4032 9.08918L21.5799 7.90918L24.0882 10.4092L22.9107 11.59L20.4032 9.08918ZM11.5815 9.08918L9.08987 11.5883L7.9082 10.4117L10.3999 7.91168L11.5815 9.08918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDue);
export default __webpack_public_path__ + "static/media/alert_due.18fad6d9a3265fa10e74efbeb3c79fd1.svg";
export { ForwardRef as ReactComponent };